import { createContext } from "react";
import * as stores from "../singletons/stores";

export const StoresContext = createContext(stores);
